<template>
  <transition name="top-notice-fade">
    <div
      v-if="visible"
      class="top-notice"
      @click="handleClick"
    >
      {{ message }}
    </div>
  </transition>
</template>

<script setup>
const props = defineProps({
  visible: Boolean,
  message: String
})

const emit = defineEmits(['close'])

const handleClick = () => {
  emit('close')
}
</script>


<style scoped>
.top-notice {
  position: sticky;
  top: 0;
  z-index: 1000;
  padding: 8px 16px;
  background: #e6f4ff;
  color: #0958d9;
  border-bottom: 1px solid #91caff;
  font-weight: 500;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
}

/* ▼▼ 애니메이션 ▼▼ */
.notice-enter-active,
.notice-leave-active {
  transition: all 0.3s ease;
}

.notice-enter-from {
  opacity: 0;
  transform: translateY(-8px);
}

.notice-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.notice-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.notice-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.top-notice:hover {
  opacity: 0.85;
}
</style>
